<h2 mat-dialog-title style="text-align: center">{{data.header}}</h2>
<mat-dialog-content class="dialog">
  @if (data.text) {
    <p>{{data.text}}</p>
  }
  @if (data.lines?.length) {
    @for (line of data.lines; track line) {
      <p class="error-line"><mat-icon color="warn" class="error-icon">error</mat-icon>{{line}}</p>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.showCancelBtn) {
    <button mat-button [mat-dialog-close]="false">בטל</button>
  }
  @if (data.showOkBtn) {
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>אישור</button>
  }
  @if (data.showCloseBtn) {
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>סגור</button>
  }
</mat-dialog-actions>
